import { render, staticRenderFns } from "./WebPartHotProductsRunner.vue?vue&type=template&id=78a0f632&scoped=true&"
import script from "./WebPartHotProductsRunner.vue?vue&type=script&lang=js&"
export * from "./WebPartHotProductsRunner.vue?vue&type=script&lang=js&"
import style0 from "./WebPartHotProductsRunner.vue?vue&type=style&index=0&id=78a0f632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a0f632",
  null
  
)

export default component.exports